import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDetailsTransactionsControllerModule } from './controllers/OrdersTransactionsController';
import { OrderDetailsTransactionsDetailView } from './detail/detail';

export const OrderDetailsTransactionsView = angular
  .module('acme.view.application.orders.detail.transactions', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    OrderDetailsTransactionsDetailView,
    OrderDetailsTransactionsControllerModule,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const ordersTransactions = {
      name: 'application.orders.detail.transactions',
      url: '/transactions',
      views: {
        'subviews-main': {
          controller: 'OrdersTransactionsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/detail/transactions/transactions.tpl.html',
        },
      },
      data: {
        pageTitle: 'Order Transactions',
        permissions: ['ORDER_VIEW'],
        enablePreferences: true,
      },
      resolve: {
        TransactionsData: [
          '$stateParams',
          'ApiService',
          function ($stateParams, ApiService) {
            return ApiService.orders.transactions($stateParams.orderId);
          },
        ],
      },
    };

    $stateProvider.state(ordersTransactions);
  }).name;
